module.exports = __webpack_public_path__ + "img/icon-briefcase.f07f5583.svg";